// Politique de confidentialité (RGPD) — Communityplace KDMARCHÉ × O'SCOP
export const privacyContent = {
  id: "politique-confidentialite",
  title: "Politique de confidentialité",
  subtitle: "Protection des données personnelles — RGPD",
  version: "{{VERSION}}",
  dateEffet: "{{DATE_EFFET}}",
  reference: "PRIV-KDM-OSCOP-2026-001",
  entity: "KDMARCHE × O'SCOP",
  accentColor: "#0B4D87",
  sections: [
    {
      number: "1",
      title: "Responsables de traitement",
      content: `Selon les finalités, vos données sont traitées par :

- **SCIC SAS OBJECTIF SCOP OUTREMER (O'SCOP)** — SIRET {{OSCOP_SIRET}}, {{OSCOP_ADDRESS}} — pour les services d'accès, abonnements, CommunityPlace, espace investisseurs et services coopératifs.
- **PRIMACOP INTERNATIONAL BUSINESS (KDMARCHÉ)** — SIRET {{KDM_SIRET}}, {{KDM_ADDRESS}} — pour les ventes de marchandises du circuit partenaire (commandes, facturation, livraison).

Contact pour la protection des données et l'exercice des droits : {{OSCOP_EMAIL}}.

**Infrastructure applicative et déploiement** : Emergent Labs Inc., 2380 Via Espada, Pleasanton, CA 94566, États-Unis — support@emergent.sh. Le service peut s'appuyer sur des fournisseurs cloud et de diffusion de contenu listés ci-dessous.`
    },
    {
      number: "2",
      title: "Données collectées",
      content: `- **Identité et contact** : nom, prénom, email, téléphone, société, SIRET, fonction.
- **Compte et accès** : identifiants, rôle, zones autorisées, journaux de connexion.
- **Transactions** : commandes, factures, moyens de paiement (gérés par Stripe — nous ne stockons pas vos données de carte), historiques de participation CommunityPlace.
- **Logistique** : adresses de livraison ou d'enlèvement, preuves de livraison (signature, horodatage).
- **Support et messagerie** : échanges avec nos équipes.

Les champs signalés par un astérisque sont obligatoires pour traiter la demande ou exécuter le service. À défaut, la demande ou la commande ne pourra pas être instruite. Les autres champs sont facultatifs.`
    },
    {
      number: "3",
      title: "Finalités et bases légales",
      content: `- **Exécution du contrat** : création de compte, commandes, livraisons, facturation, abonnements.
- **Obligations légales** : comptabilité, fiscalité, lutte contre la fraude.
- **Intérêt légitime** : sécurité de la plateforme, prévention de la fraude, statistiques d'usage, amélioration des services.
- **Consentement** : communications commerciales et alertes (désinscription possible à tout moment).`
    },
    {
      number: "4",
      title: "Destinataires et sous-traitants",
      content: `Vos données sont accessibles aux équipes habilitées d'O'SCOP et de PRIMACOP INTERNATIONAL BUSINESS, ainsi qu'à nos sous-traitants dans la stricte limite de leurs prestations :

- **Stripe**, lorsqu'il est activé pour le paiement — données de transaction ;
- **Brevo**, lorsqu'il est activé pour les messages transactionnels ou commerciaux — adresse email et nom ;
- **Emergent Labs Inc.** — développement, déploiement et infrastructure applicative ;
- **PostHog**, lorsque la mesure d'audience est acceptée — données de navigation et identifiants pseudonymes ;
- **Cloudflare et fournisseurs cloud utilisés par Emergent** — sécurité, diffusion du contenu et hébergement technique ;
- **Prestataires de maintenance habilités** — accès limité à ce qui est strictement nécessaire ;
- **LOGI'SCOP** (établissement de la SCIC O'SCOP) — données nécessaires aux livraisons.

Nous ne vendons ni ne louons vos données personnelles.`
    },
    {
      number: "5",
      title: "Transferts hors Union européenne",
      content: `Emergent Labs Inc. est établie aux États-Unis et indique pouvoir recourir à des infrastructures situées notamment aux États-Unis et en Inde. PostHog, Stripe, Brevo, Cloudflare ou leurs sous-traitants peuvent également traiter certaines données hors de l'Espace économique européen. Lorsque ces services sont utilisés, les transferts sont encadrés par une décision d'adéquation, des clauses contractuelles types de la Commission européenne et, lorsque nécessaire, des mesures supplémentaires. Des informations peuvent être demandées à {{OSCOP_EMAIL}}.`
    },
    {
      number: "6",
      title: "Durées de conservation",
      content: `- **Compte et accès** : durée de la relation contractuelle, puis 3 ans à des fins de prospection (professionnels).
- **Factures et pièces comptables** : 10 ans (obligations légales).
- **Preuves de livraison et journaux d'audit** : durée légale de conservation probatoire.
- **Données de paiement** : conservées par Stripe selon ses propres obligations ; nous conservons uniquement les références de transaction.`
    },
    {
      number: "7",
      title: "Vos droits",
      content: `Vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données, ainsi que du droit de définir des directives post-mortem et de retirer votre consentement à tout moment, sans porter atteinte à la licéité du traitement antérieur.

Pour exercer vos droits : {{OSCOP_EMAIL}} (justificatif d'identité possible en cas de doute).

Vous pouvez introduire une réclamation auprès de la **CNIL** (www.cnil.fr).`
    },
    {
      number: "8",
      title: "Cookies et traceurs",
      content: `La plateforme utilise des traceurs strictement nécessaires au fonctionnement (session, sécurité, panier et préférences), qui ne requièrent pas de consentement. Les traceurs de mesure d'audience, d'enregistrement de session ou de conversion ne sont activés qu'après un consentement libre, spécifique et préalable. Le bandeau permet de tout accepter ou tout refuser avec le même degré de simplicité. Le choix peut être retiré à tout moment depuis le bouton permanent « Gérer mes cookies ». Le refus des traceurs non essentiels n'empêche pas l'accès au service.`
    },
    {
      number: "9",
      title: "Sécurité",
      content: `Nous mettons en œuvre des mesures techniques et organisationnelles appropriées : chiffrement des échanges (HTTPS), mots de passe hachés, contrôles d'accès par rôles, journalisation des actions sensibles et sauvegardes.`
    },
    {
      number: "10",
      title: "Mise à jour de la politique",
      content: `La présente politique peut être mise à jour pour rester conforme à la réglementation et à l'évolution des services. La version applicable est celle publiée sur la plateforme, avec sa date d'effet.`
    }
  ]
};
